// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PriceDimension.yaml
// Generated: 2026-10-20T12:35:31.456Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePriceDimension, UpdatePriceDimension, PriceDimension } from '@/types/forestry/PriceDimension';

/**
 * PriceDimension Service
 * CRUD operations for PriceDimension via the ABP API.
 */
export const priceDimensionService = new EntityService<PriceDimension, CreatePriceDimension, UpdatePriceDimension>(
  '/api/forestry/pricedimension',
  'PriceDimension',
);
